module.exports = __webpack_public_path__ + "img/news06.af5d109b.jpeg";